<template>
  <base-section
    id="camera-ready-special"
  >
    <v-container>
      <base-section-heading
      title="Camera-ready instructions for Special Tracks Papers accepted for Formal Proceedings"
      >
      <div style="text-align: left !important">
       Below you find the instructions to submit your camera-ready version. In the case of questions or problems please contact the Publication Chairs (see bottom of this page).
       <br>
       <strong>Paper Format:</strong><br>
       • The maximum length of the camera-ready manuscript depends on the category:<br>
        &emsp;&emsp;■ Special papers (approved by the Program Chair) - 10 pages <br>
        &emsp;&emsp;■ Panel papers (approved by the Program Chair) - 1 page <br>
       • Paper must be in the IEEE proceedings two-column format (<strong>A4 size</strong>). You can find
<a href="https://www.ieee.org/conferences_events/conferences/publishing/templates.html">here</a> the templates provided by IEEE. Prior to submission, <strong> check if your PDF satisfies the A4 format (11.69×8.27in)</strong>. In Adobe Reader you can check this by clicking on file->properties and look for page size in the Description tab. <u><strong>Papers submitted in Letter format will not be considered.</strong></u><br>
       • <strong>Important!</strong> Do not include page numbers in your paper, a copyright footer information or any other headers or footers.<br>
       • The deadline for camera ready and copyright form upload is <strong>March 31st, 2023</strong>. You can find more instructions on this next.<br>
      </div>
      </base-section-heading>
      <base-section-heading
      title="PDF Check and Upload"
      >
      <div style="text-align: left !important">
        • Use IEEE PDF eXpress tools to check for PDF compatibility and for papers upload <br>
        • The PDF eXpress site can be accessed <a href="https://ieee-pdf-express.org/">here</a>, the <strong>Conference ID is 56758X</strong>. <br>
        • Once the paper has been checked (you will be notified by an email), please access again <a href="https://ieee-pdf-express.org/">PDF eXpress</a> and click on the <strong>“Approve”</strong> icon on the right side in the “Action” column.<br> <strong>Be careful</strong>: without clicking on “Approve”, the Publication Chair will not receive your PDF file.<br>
        • If you are having problems using PDF Express, please contact the Publication Chairs.
      </div>
      </base-section-heading>
      <base-section-heading
      title="Copyright Form"
      >
      <div style="text-align: left !important">
Please fill the following fields and follow the instructions given in the next pages.<br><br>
<v-form
    ref="form"
    action="https://welcome.molesystems.com/tttc/ETS/2023/transferCopyright.php"
    method="post"
    id="copy-form-special"
    name=copyrightForm
    >
<v-text-field
    outlined
    name="ArtTitle"
    value=""
    label="Paper Title*"
    required
    clearable
    />
<v-text-field
    outlined
    name="AuthName"
    value=""
    label="Authors*"
    required
    clearable
    />
<v-text-field
    outlined
    name="AuthEmail"
    value=""
    label="Contact Author's Email*"
    required
    clearable
    />
Copyright type*:<br>
<input
    type=radio
    name="copyrightType"
    value="CRWN"
    >
    <u>All authors</u> are employed by a Crown government (UK, Canada, and Australia) <br>
<input
    type=radio
    name="copyrightType"
    value="USG"
    >
    <u>All authors</u> are employed by the US government <br>
<input
    type=radio
    name="copyrightType"
    value="US"
    checked
    >
    Regular copyright <br>

<!---
    <v-radio-group v-model="copytype">
<v-radio name="copyrightType" value="CRWN" label="All authors are employed by a Crown government (UK, Canada, and Australia)"> </v-radio>
<v-radio name="copyrightType" value="USG" label="All authors are employed by the US government"> </v-radio>
<v-radio name="copyrightType" value="US" label="Regular copyright"> </v-radio>
    </v-radio-group>
    --->

<br>
  <v-btn
    type="submit"
    value="Send Copyright Form"
    color="primary"
    style="text-align: center !important"
    form="copy-form-special"
    >
    Send Copyright Form</v-btn>
<span class="font-weight-bold ml-6 mr-4 my-4"></span>
<v-btn
    type="reset"
    style="text-align: center !important"
    @click="reset"
    >
    Reset</v-btn>
</v-form>
      </div>
      </base-section-heading>
      <base-section-heading
      title="Contacts"
      >
      <v-row>
        <v-col
          v-for="(pub, i) in publications"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="pub"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      </base-section-heading>
      </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'CameraReadySpecial',

    data () {
    return {
      copytype: 'US',
      isMobile: false,
      submissionsfooter: [
        {
          name: 'Submissions',
          url: 'submissions',
        },
        {
          name: 'Key Dates',
          url: 'key-dates',
        },
        {
          name: 'Topics',
          url: 'topics',
        },
        {
          name: 'Submit a Paper',
          url: 'cfp',
        },
        {
          name: 'Submission Guidelines',
          url: 'submission-guidelines',
        },
      ],
      publications: [
        {
          title: 'Mottaqiallah Taouil',
          src: require('@/images/committees/taouil.jpg'),
          text: 'TU Delft, NL, m.taouil@tudelft.nl ',
        },
        {
          title: 'Tara Ghasempuori',
          src: require('@/images/committees/ghasempouri.jpg'),
          text: 'Taltech, EE, tara.ghasempouri@taltech.ee',
        },
      ],
    }
    },
    mounted () {
      //  this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
    },
    methods: {
      reset () {
        this.$refs.form.reset()
      },
      isMobileDevice () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
    },
  }
</script>
